var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{attrs:{"elevation":"0"}},[_c('v-card-title',[_c('v-icon',[_vm._v("mdi-download")]),_vm._v(" Download Latest File ")],1),_c('v-card-text',[_vm._v(" Under construction ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }